import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppHttpClient } from './app-http-client.service';
import { LeadershipStipendConfig } from '../models/leadership-stipend-config.model';

@Injectable({
  providedIn: 'root'
})
export class LeadershipStipendConfigService {

  constructor(
    public http: AppHttpClient
  ) { }

  // GET /admin/stipend/config?year=YYYY -> full LeadershipStipendConfig
  getConfig(year: number): Observable<LeadershipStipendConfig> {
    return this.http.get<LeadershipStipendConfig>('stipend/config?year=' + year);
  }

  // PUT /admin/stipend/config (body = full config incl. year)
  saveConfig(config: LeadershipStipendConfig): Observable<any> {
    return this.http.put('stipend/config', config);
  }
}
